import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1733270c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ThirdPartyPhoneResourceStatistics" }
const _hoisted_2 = { class: "statistics" }

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { useStore } from '@/store'
import { initEmptyParam } from '@/hooks/useInitParam'
import dayjs from 'dayjs'
import { getListData, getPageListData } from '@/service/main/system'
import { ref, onMounted, watch, computed } from 'vue'
import { ElLoading, ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'ThirdPartyPhoneResourceStatistics',
  setup(__props) {
initEmptyParam()
const store = useStore()

const formatRate = (rateStr: any, rate: any) => {
  if (rateStr !== null && rateStr !== undefined && rateStr !== '') {
    return rateStr
  }
  if (rate !== null && rate !== undefined && rate !== '') {
    return `${rate}%`
  }
  return '--'
}

const queryParam = {
  thirdParty: '',
  timeSlot: [
    dayjs().startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ],
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)

// 获取第三方列表
const getThirdPartyList = async () => {
  try {
    let thirdPartyData = await getListData(
      '/main/customerChannel/queryMainThirdParty',
      {}
    )
    const thirdPartyItem = searchFormConfig.formItems.find(
      (item) => item.field === 'thirdParty'
    )
    if (thirdPartyItem) {
      thirdPartyItem.options = thirdPartyData.map((item: any) => {
        return { title: item, value: item }
      })
    }
  } catch (error) {
    console.error('获取第三方列表失败', error)
  }
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const statistics = ref({
  resourcesCount: '--',
  repeatRate: '--',
  repeatWithinSixMonthRate: '--',
  deleteRate: '--',
  totalDeleteRate: '--',
  invalidNum: '--',
  thCount: '--',
  openRate: '--',
  lookRate: '--',
  dealCount: '--',
  monthConversionRate: '--',
  lastMonthConversionRate: '--',
  accConversionRate: '--'
})

const listData = computed(() =>
  store.getters['system/pageListData']('thirdPartyPhoneResourceStatistics')
)

watch(listData, (newData) => {
  if (newData && newData.length > 0) {
    const data = newData[0] || {}
    statistics.value = {
      resourcesCount: data.resourcesCount ?? '--',
      repeatRate: data.repeatRate ?? '--',
      repeatWithinSixMonthRate: formatRate(data.repeatWithinSixMonthRateStr, data.repeatWithinSixMonthRate),
      deleteRate: data.deleteRate ?? '--',
      totalDeleteRate: data.totalDeleteRate ?? '--',
      invalidNum: data.invalidNum ?? '--',
      thCount: data.thCount ?? '--',
      openRate: data.openRate ?? '--',
      lookRate: data.lookRate ?? '--',
      dealCount: data.dealCount ?? '--',
      monthConversionRate: data.monthConversionRate ?? '--',
      lastMonthConversionRate: data.lastMonthConversionRate ?? '--',
      accConversionRate: data.accConversionRate ?? '--'
    }
  } else {
    // 清空统计数据
    statistics.value = {
      resourcesCount: '--',
      repeatRate: '--',
      repeatWithinSixMonthRate: '--',
      deleteRate: '--',
      totalDeleteRate: '--',
      invalidNum: '--',
      thCount: '--',
      openRate: '--',
      lookRate: '--',
      dealCount: '--',
      monthConversionRate: '--',
      lastMonthConversionRate: '--',
      accConversionRate: '--'
    }
  }
})

const handlePageData = async (params: any) => {
  const loading = ElLoading.service({
    lock: true,
    text: '加载中...',
    background: 'rgba(255, 255, 255, 0.7)'
  })

  try {
    const res = await getPageListData('/main/thirdPartyPhoneAccountConfig/resourceStatistics', params)
    if (res.list) {
      store.commit('system/changeThirdPartyPhoneResourceStatisticsList', res.list)
      store.commit('system/changeThirdPartyPhoneResourceStatisticsCount', Number(res.total))
    }
  } catch (error) {
    console.error('加载数据失败', error)
    ElMessage.error('加载数据失败')
  } finally {
    loading.close()
  }
}

onMounted(() => {
  // 只获取第三方列表，不调用数据接口
  getThirdPartyList()
})

const resetCb = () => {
  return { ...queryParam }
}

// 自定义搜索逻辑：验证必填字段并调用接口
const handleSearchClickCustom = async (formdata: any) => {
  // 验证所属第三方必须有值
  if (!formdata.thirdParty) {
    ElMessage.warning('请选择所属第三方')
    return
  }

  // 验证加入时间必须有值
  if (!formdata.timeSlot || formdata.timeSlot.length !== 2) {
    ElMessage.warning('请选择加入时间')
    return
  }

  // 调用数据加载
  await handlePageData(formdata)
}

// 自定义重置逻辑
const handleResetClickCustom = async () => {
  // 清空统计数据
  statistics.value = {
    resourcesCount: '--',
    repeatRate: '--',
    repeatWithinSixMonthRate: '--',
    deleteRate: '--',
    totalDeleteRate: '--',
    invalidNum: '--',
    thCount: '--',
    openRate: '--',
    lookRate: '--',
    dealCount: '--',
    monthConversionRate: '--',
    lastMonthConversionRate: '--',
    accConversionRate: '--'
  }

  // 使用默认参数重新加载
  await handlePageData(queryParam)
}

const [pageContentRef, _, __, handleDownBtnClick] = usePageSearch()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: handleResetClickCustom,
      onSearchBtnClick: handleSearchClickCustom
    }, null, 8, ["searchFormConfig"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, [
        _createTextVNode("资源数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.resourcesCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("重复率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.repeatRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("6个月内重复率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.repeatWithinSixMonthRate), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("24小时删除率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.deleteRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("累计删除率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.totalDeleteRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("重叠数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.invalidNum), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("同行数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.thCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("开口率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.openRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("看课率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.lookRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("成交资源数: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.dealCount), 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("当月转化率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.monthConversionRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("上月转化率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.lastMonthConversionRate) + "%", 1)
      ]),
      _createElementVNode("span", null, [
        _createTextVNode("累积转化率: "),
        _createElementVNode("em", null, _toDisplayString(statistics.value.accConversionRate) + "%", 1)
      ])
    ]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "thirdPartyPhoneResourceStatistics",
      pageUrl: "/main/thirdPartyPhoneAccountConfig/resourceStatistics",
      downFilename: "三方电话资源统计.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onSortChange: handleSortChange
    }, {
      repeatRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.repeatRate) + "%", 1)
      ]),
      repeatWithinSixMonthRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(formatRate(
              scope.row.repeatWithinSixMonthRateStr,
              scope.row.repeatWithinSixMonthRate
            )), 1)
      ]),
      deleteRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.deleteRate) + "%", 1)
      ]),
      totalDeleteRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.totalDeleteRate) + "%", 1)
      ]),
      openRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.openRate) + "%", 1)
      ]),
      lookRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.lookRate) + "%", 1)
      ]),
      monthConversionRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.monthConversionRate) + "%", 1)
      ]),
      lastMonthConversionRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.lastMonthConversionRate) + "%", 1)
      ]),
      accConversionRate: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.accConversionRate) + "%", 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})